import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Color } from '../../config/Color';
import { appOverride } from '../../util/AppUtils';
import { AppIcons } from '../assets/images/Icons';
import { ProminentContainer } from '../styles/Containers';
import { BodySM, BodyXXS } from '../styles/Typography';
import { BridgeType, StepList, StepListProps } from './StepList';

export type ProgramSummaryProgramField = { field: string; answers: string };

type ProgramSummaryProps = {
  title: string;
  programFields: ProgramSummaryProgramField[];
  programContents: StepListProps;
  postProgramTitle?: string;
  postProgramContent: string;
};

export const ProgramSummary: FunctionComponent<ProgramSummaryProps> = (props) => {
  const { title, programFields, programContents, postProgramTitle, postProgramContent } = props;

  return (
    <MainContainer>
      <TopContainer>
        <BodySM>
          <b>{title}</b>
        </BodySM>
        {programFields.map((program, index) => (
          <BodyXXS key={index}>
            <b>{program.field}: </b>
            <span data-test={program.field}>{program.answers}</span>
          </BodyXXS>
        ))}
      </TopContainer>
      <BottomContainer>
        <StepList {...programContents} showSmallIcons />
        <StepList
          items={[
            {
              title: postProgramTitle,
              desc: postProgramContent,
              image: AppIcons.unlocked,
            },
          ]}
          bridgeType={BridgeType.Line}
          showSmallIcons
        />
      </BottomContainer>
    </MainContainer>
  );
};

const TopContainer = styled.div`
  background: ${appOverride({ nerva: Color.flow.muted, default: Color.surface.accent })};
  padding: ${({ theme }) => `${theme.spacing._20px} ${theme.spacing._32px}`};
  border-radius: 22px 22px 0 0;
`;

const BottomContainer = styled.div`
  padding: ${({ theme }) => theme.spacing._16px};
`;

const MainContainer = styled(ProminentContainer)`
  border-radius: ${({ theme }) => theme.spacing._22px};
  margin: 0;
  padding: 0;
  background: ${appOverride({
    nerva: 'rgba(255, 255, 255, 0.1)',
    default: Color.subscription.accent,
  })};
`;
